import {
  Directive,
  TemplateRef,
  ViewContainerRef,
  effect,
  inject,
  input,
} from '@angular/core';
import { FeatureModule } from './feature.model';
import { FeatureService } from './feature.service';

/**
 * Directiva estructural: muestra su contenido solo si el tenant activo tiene el
 * módulo. Reacciona a cambios de sesión (cambio de plan, login/logout).
 *
 *   <a *appFeature="'descuentos'" routerLink="/discounts">Descuentos</a>
 */
@Directive({
  selector: '[appFeature]',
  standalone: true,
})
export class FeatureDirective {
  readonly appFeature = input.required<FeatureModule>();

  private tpl = inject(TemplateRef<unknown>);
  private vcr = inject(ViewContainerRef);
  private features = inject(FeatureService);

  constructor() {
    effect(() => {
      const allowed = this.features.has(this.appFeature());
      this.vcr.clear();
      if (allowed) {
        this.vcr.createEmbeddedView(this.tpl);
      }
    });
  }
}
